<template>
    <div class="card mb-3 flex-grow-1 w-100 border-left-indigo border-left-3">
        <div class="card-body p-0 d-flex flex-column">
            <div class="d-flex flex-column flex-md-row align-items-stretch flex-grow-1">
                <div class="p-4 d-flex align-items-center flex-grow-1">
                    <i class="icon-coins icon-2x mr-2"></i>
                    <div class="flex-grow-1">
                        <div class="d-flex align-items-baseline">
                            <span class="text-muted font-size-sm mr-2">{{ $t('paymentTable.aiBalance.title') }}</span>
                        </div>
                        <div class="d-flex align-items-baseline mt-1" style="line-height: 1.05;">
                            <span class="font-weight-semibold" style="font-size: 30px; color: rgb(51, 51, 51);">{{ formatNumber(balance) }}</span>
                            <span class="ml-2 text-muted" style="font-size: 15px;">{{ $t('paymentTable.aiBalance.currency') }}</span>
                        </div>
                        <div class="d-flex align-items-baseline">
                            <router-link :to="{ name: 'AiTransactionsIndexPage' }">{{ $t('buttons.view_history') }}</router-link>
                        </div>
                    </div>
                </div>
                <div class="ai-balance-action p-4 d-flex flex-column justify-content-center">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted font-size-sm">{{ $t('paymentTable.aiBalance.topUpTitle') }}</span>
                        <span class="font-size-xs text-muted">{{ $t('paymentTable.aiBalance.minAmount') }}</span>
                    </div>
                    <div class="topup-amount-row mb-2">
                        <div class="topup-custom-inline" v-if="customCost">
                            <button type="button" class="btn btn-sm preset-chip preset-chip-icon" :title="$t('paymentTable.aiBalance.backToPresets')" @click="selectCustomCost(false)">
                                <i class="icon-arrow-left13"></i>
                            </button>
                            <div class="topup-input-wrap">
                                <input type="number" class="form-control form-control-sm topup-input" v-model="selectedCost">
                                <span class="topup-input-suffix">грн</span>
                            </div>
                        </div>
                        <template v-else>
                            <button type="button" :class="['btn', 'btn-sm', 'preset-chip', { active: selectedCost === cost }]" v-for="cost in costs" @click="selectedCost = cost" :key="cost">{{ cost }}</button>
                            <button type="button" class="btn btn-sm preset-chip preset-chip-icon" :title="$t('paymentTable.aiBalance.customAmount')" @click="selectCustomCost(true)">
                                <i class="icon-pencil"></i>
                            </button>
                        </template>
                    </div>
                    <AppButton color="indigo" @click="topUpBalance">
                        <i class="icon-plus-circle2 mr-2"></i>
                        <span v-if="customCost">{{ $t('paymentTable.aiBalance.topUpButton') }}</span>
                        <span v-else>{{ $t('paymentTable.aiBalance.topUpButtonWithCost', { cost: selectedCost }) }}</span>
                    </AppButton>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppButton from '../../../../../components/new/button/AppButton.vue';

import { httpClient } from '../../../../../services/HttpClient.ts';

export default {
    name: "AiBalanceCard",
    components: {
        AppButton
    },
    props: {
        formatNumber: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            balance: 0,
            costs: [100, 200, 500, 1000],
            selectedCost: 100,
            customCost: false
        }
    },
    methods: {
        selectCustomCost(custom) {
            this.customCost = custom;
            this.selectedCost = 100
        },
        fetchBalance() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/core/ai-transactions/balance`).then(response => {
                this.balance = response.data.balance;
            });
        },
        topUpBalance() {
            httpClient.post(`/projects/${this.$route.params.projectUuid}/core/payments`, {
                sum: this.selectedCost
            }).then(response => {
                window.location.href = response.data.data.external_url;
            });
        }
    },
    mounted() {
        this.fetchBalance();
    },
}
</script>
<style scoped>
.ai-balance-action {
    background: #FAFBFC;
    border-left: 1px solid #ECEFF1;
    width: 280px;
    flex-shrink: 0;
}
.preset-chip.active {
    background: #3F51B5;
    border-color: #3F51B5;
    color: #fff;
}
.topup-amount-row {
    display: flex;
    gap: 6px;
    flex-wrap: nowrap;
    align-items: stretch;
}
.preset-chip {
    border: 1px solid #D5D8DC;
    background: #fff;
    color: #555;
    min-width: 48px;
    padding: 4px 10px;
    font-weight: 500;
    border-radius: 4px;
    transition: all .15s ease-in-out;
}
.preset-chip:hover {
    border-color: #3F51B5;
    color: #3F51B5;
}
.preset-chip.active:hover {
    background: #3F51B5;
    border-color: #3F51B5;
    color: #fff;
}
.topup-amount-row .preset-chip {
    flex: 1 1 0;
    min-width: 0;
    padding-left: 4px;
    padding-right: 4px;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.topup-amount-row .preset-chip-icon {
    flex: 0 0 38px;
    font-size: 12px;
}
.topup-input-wrap {
    position: relative;
    flex: 1;
    display: flex;
}
.topup-input-suffix {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #999;
    pointer-events: none;
    font-weight: 500;
    white-space: nowrap;
}
.topup-input {
    flex: 1;
    height: 30px !important;
    padding: 4px 36px 4px 10px !important;
    border: 1px solid #E0E3EA !important;
    border-radius: 4px !important;
    background: #fff !important;
    font-weight: 600;
    font-size: 13px;
    font-variant-numeric: tabular-nums;
}
.topup-custom-inline {
    display: flex;
    gap: 6px;
    width: 100%;
    align-items: stretch;
    height: 30px;
}
</style>